/**
 * @generated SignedSource<<30e80bd6e661ea4de50d3ce621dcf79d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PromotionProductEventUpsertInput = {
  description?: string | null;
  discounts?: ReadonlyArray<PromotionProductDiscountDetailInput> | null;
  durationDays?: number | null;
  durationHours?: number | null;
  exposeToAnonymous?: boolean | null;
  offsetHours?: number | null;
  promotionId: string;
  title: string;
};
export type PromotionProductDiscountDetailInput = {
  amount: number;
  backgroundColor?: string | null;
  mobileImage?: Upload | null;
  productId: string;
  webImage?: Upload | null;
};
export type Upload = {
  fieldName?: string | null;
  key: string;
  multipartUploadResult?: MultiPartUploadResult | null;
  objectUrl?: string | null;
  size: number;
};
export type MultiPartUploadResult = {
  partPairs: ReadonlyArray<PartPair>;
  uploadId: string;
};
export type PartPair = {
  ETag: string;
  PartNumber: number;
};
export type PromotionProductEventUpsertDialog_promotionProductEventUpsertMutation$variables = {
  input: PromotionProductEventUpsertInput;
};
export type PromotionProductEventUpsertDialog_promotionProductEventUpsertMutation$data = {
  readonly promotionProductEventUpsert: {
    readonly discounts: ReadonlyArray<{
      readonly amount: number;
      readonly product: {
        readonly id: string;
      };
    }>;
    readonly durationDays: number | null;
    readonly durationHours: number | null;
    readonly offsetHours: number;
    readonly title: string;
  };
};
export type PromotionProductEventUpsertDialog_promotionProductEventUpsertMutation = {
  response: PromotionProductEventUpsertDialog_promotionProductEventUpsertMutation$data;
  variables: PromotionProductEventUpsertDialog_promotionProductEventUpsertMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offsetHours",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationHours",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationDays",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v6/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PromotionProductEventUpsertDialog_promotionProductEventUpsertMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PromotionProductEvent",
        "kind": "LinkedField",
        "name": "promotionProductEventUpsert",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductDiscount",
            "kind": "LinkedField",
            "name": "discounts",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PromotionProductEventUpsertDialog_promotionProductEventUpsertMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PromotionProductEvent",
        "kind": "LinkedField",
        "name": "promotionProductEventUpsert",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductDiscount",
            "kind": "LinkedField",
            "name": "discounts",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7c0c999ee76b1e2d7bd31f6120ebfb99",
    "id": null,
    "metadata": {},
    "name": "PromotionProductEventUpsertDialog_promotionProductEventUpsertMutation",
    "operationKind": "mutation",
    "text": "mutation PromotionProductEventUpsertDialog_promotionProductEventUpsertMutation(\n  $input: PromotionProductEventUpsertInput!\n) {\n  promotionProductEventUpsert(input: $input) {\n    title\n    offsetHours\n    durationHours\n    durationDays\n    discounts {\n      product {\n        id\n      }\n      amount\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0a8e6a352716911a2cfe2f6a0a5426d1";

export default node;
